import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { Grid } from '@mui/material'

import { Image } from '@/api/image'
import {
    organizationLogoQueryOptions,
    useUpdateOrganizationLogoMutation
} from '@/api/organizationsQueryOptions'
import { fetchDetailPermissionsQueryOptions } from '@/api/permissionsQueryOptions'
import ImageUpload from '@/components/image/ImageUpload'
import LoadProgress from '@/components/LoadProgress'
import { setLogo } from '@/store/auth/authSlice'
import { useDispatch } from 'react-redux'

export const Route = createFileRoute(
    '/_auth/organization_/$organizationUuid/images',
)({
    component: OrganizationComponent,
})

function OrganizationComponent() {
    const params = Route.useParams()
    const organizationLogoQuery = useSuspenseQuery(
        organizationLogoQueryOptions(params.organizationUuid),
    )
    const organizationLogo = organizationLogoQuery.data

    const organizationLogoMutation = useUpdateOrganizationLogoMutation(
        params.organizationUuid,
    )

    const permissionsQuery = useSuspenseQuery(fetchDetailPermissionsQueryOptions('organization', params.organizationUuid, ['logo']))
    const permissions = permissionsQuery.data

    const dispatch = useDispatch()

    if (
        organizationLogoQuery.isLoading ||
        organizationLogoQuery.isFetching
    ) {
        return <LoadProgress />
    }
    if (permissionsQuery.isLoading || permissionsQuery.isFetching) {
        return <LoadProgress />
    }

    const changeLogo = permissions && permissions.filter(p => p.detail === 'logo' && p.permissions.some(a => a === 'write')).length > 0

    const onLogoUpload = (image: Image) => {
        organizationLogoMutation.mutate({
            referenceUuid: params.organizationUuid,
            ...image,
        } as Image)
        dispatch(setLogo(image))
    }


    return (
        (<form>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}>
                    <div>
                        <Grid container spacing={1}>
                            <Grid size={12}>Logo</Grid>
                            <Grid size={12}>
                                <img
                                    src={`data:image/jpeg;base64,${organizationLogo && organizationLogo.base64}`}
                                    alt=""
                                    width="200px"
                                />
                            </Grid>
                            <Grid size={12}>
                                {changeLogo &&
                                    <ImageUpload onUpload={onLogoUpload} />
                                }
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </form>)
    );
}
